export default {
    PAGE_ID_GLOSSAR : 593,
    PAGE_ID_STARTSEITE : 668,
    POST_ID_HIV_IM_ALLTAG : 688,
    POST_ID_HIV_INFEKTION_UND_THERAPIE : 686,
    POST_ID_MEINSGLEICHEN : 56,
    POST_ID_UEBER_HIV_REDEN : 687,
    SERIES_KEYWORD_ID_FEATURE : 157,
}
